import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { connect } from 'react-redux';

const ProtectedRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      rest.isAuthenticated ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/iniciar-sesion',
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

const mapStateToProps = state => {
  const { token } = state.auth;
  const isAuthenticated = token !== null && token !== undefined;
  return {
    isAuthenticated,
  };
};

export default connect(mapStateToProps)(ProtectedRoute);



// WEBPACK FOOTER //
// ./src/components/HOC/ProtectedRoute.js